<template>
	<div
		class="notificacoes no-print animated"
		:style="{'width': width, 'margin-top': marginTop}"
		v-if="exibirNotificacoes"
		:class="slide"
	>
		<div class="fl-cabecalho">
			<div class="row">
				<div class="col-xs-8">
					<div style="position: relative; float: left; width: 230px">
						<i
							class="icon fa fa-bell-o fa-fw"
							style="margin-right: 4px; font-size: 28px"
						></i>
						<h3 style="font-size: 22px; margin-left: 0px; margin-top: 2px">
							{{ _traducao('global', 'notificacao') }}
						</h3>
					</div>
				</div>

				<div class="col-xs-4">
					<i
						class="icon-close fechar fechar-notificacao"
						style="margin-top: 0px"
						@click="slide = _isMobile ? 'slideOutRight' : 'slideOutLeft'"
					></i>
				</div>
			</div>
		</div>

		<div class="row" style="margin-top: 14px">
			<div class="col-xs-12 text-left">
				<div style="margin-left: 8px">
					<small v-if="lista.length > 0" :style="{color: colorFont}"
						>{{ _traducao('global', 'voceTem') }} {{ lista.length }}
						{{ _traducao('global', 'hNotificacao') }}.</small
					>
					<small v-if="lista.length == 0" :style="{color: colorFont}"
						>{{ _traducao('global', 'nenhumaNotificacao') }}.</small
					>
					<br />

					<a
						href="#"
						class="link-limpar"
						@click.prevent="clickLimparTodas()"
						v-if="lista.length > 0 && !exibirHistorico"
					>
						<i class="fa fa-fw fa-trash-o"></i
						>{{ _traducao('global', 'limpaTudas') }}
					</a>

					<a
						href="#"
						v-if="!exibirHistorico"
						@click.prevent="
							exibirHistorico = true
							colorFont = '#F9F9F9'
						"
						class="pull-right link-historico"
					>
						<i class="fa fa-fw fa-history" aria-hidden="true"></i
						>{{ _traducao('global', 'historico') }}
					</a>

					<a
						href="#"
						v-if="exibirHistorico"
						@click.prevent="limpaHistorico()"
						class="pull-right link-historico"
					>
						<i class="fa fa-fw fa-arrow-left" aria-hidden="true"></i
						>{{ _traducao('global', 'hNotificacao') }}
					</a>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-xs-12">
				<hr style="margin-top: 4px; margin-bottom: 10px" />
			</div>
		</div>

		<!-- NOTIFICAÇÕES -->
		<div
			:style="{width: width}"
			style="padding-right: 15px"
			v-show="!exibirHistorico"
		>
			<div ref="configScrollN">
				<div
					v-for="(item, index) in lista"
					class="animated"
					:class="item.class"
					:key="index"
				>
					<div class="row" style="margin-right: 26px">
						<div class="col-xs-12 item-notificacao">
							<p style="font-size: 13px">
								<strong v-if="item.assunto">{{
									item.assunto.toUpperCase()
								}}</strong>
								<span
									class="pull-right"
									style="color: #777; font-size: 0.9em"
									>{{ item.dt }}</span
								>
							</p>
							<p style="font-size: 12px" v-html="item.conteudo"></p>
							<div>
								<a
									href="#"
									class="pull-left link-limpar"
									@click.prevent="clickLimpar(item, index)"
								>
									<span v-if="!item.excluindo"
										><i class="fa fa-fw fa-trash-o"></i
										>{{ _traducao('global', 'limpar') }}</span
									>
									<span v-if="item.excluindo"
										><i class="fa fa-refresh fa-spin fa-fw"></i
									></span>
								</a>
								<div @click="clickVer(item)">
									<router-link
										v-if="item.acao == '1'"
										class="pull-right link-ver"
										:to="{name: item.rota, params: item.params}"
									>
										Ver<i class="fa fa-fw fa-chevron-right"></i>
									</router-link>
								</div>
								<!--<a href="#" class="pull-right link-ver" v-if="item.acao == '1'" @click.prevent.stop="clickVer(item)">
                                    Ver<i class="fa fa-fw fa-chevron-right"></i>
                                </a> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- HISTÓRICO -->
		<div v-show="exibirHistorico">
			<div class="row">
				<div class="col-md-8 col-md-offset-2 col-xs-12">
					<label>{{ _traducao('global', 'escolhaData') }}:</label>
					<div class="input-group">
						<flDateTime
							@v-model="(val) => (form.data = val)"
							:value="form.data"
							:lang="_getLangDp"
							:placeholder="_formatDate"
							name="teste"
							:disabled="carregando"
							:format="_formatDate"
						/>
						<span class="input-group-btn">
							<button
								class="btn btn-sm btn-success"
								:disabled="carregando"
								@click="clickCarregaHistorico()"
								type="button"
							>
								<i
									class="fa fa-fw fa-refresh"
									:class="{'fa-spin': carregando}"
								></i
								>{{ _traducao('global', 'cCarregar') }}
							</button>
						</span>
					</div>
					<p class="text-danger" v-if="erro != ''">{{ erro }}</p>
				</div>
			</div>
			<div v-show="buscouHistorico">
				<div class="row" style="margin-top: 20px">
					<div class="col-xs-12 text-center">
						<p v-if="historicos.length > 0">
							{{ historicos.length }}
							{{ _traducao('global', 'notificacaoEncontrada') }}.
						</p>
						<p v-if="historicos.length == 0">
							{{ _traducao('global', 'nenhumaNotificacaoEncontrada') }}.
						</p>
					</div>
				</div>

				<div :style="{width: width}" style="padding-right: 15px">
					<div ref="configScrollS">
						<div
							v-for="(item, index) in historicos"
							class="animated"
							:key="index"
							:class="item.class"
						>
							<div class="row" style="margin-right: 26px">
								<div class="col-xs-12 item-notificacao">
									<p style="font-size: 13px">
										<strong v-if="item.assunto">{{
											item.assunto.toUpperCase()
										}}</strong>

										<span
											class="pull-right"
											style="color: #777; font-size: 0.9em"
											>{{ item.dt }}</span
										>
									</p>
									<p style="font-size: 12px">{{ item.conteudo }}</p>
									<div>
										<span style="color: #777; font-size: 0.9em">{{
											item.data_envio | tempo
										}}</span>
										<a
											href="#"
											class="pull-left link-limpar"
											@click.prevent="clickLimpar(item, index)"
										>
											<span v-if="item.excluindo"
												><i class="fa fa-refresh fa-spin fa-fw"></i
											></span>
										</a>
										<div @click="clickVer(item)">
											<router-link
												v-if="item.acao == '1'"
												class="pull-right link-ver"
												:to="{name: item.rota, params: item.params}"
											>
												Ver<i class="fa fa-fw fa-chevron-right"></i>
											</router-link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import flDateTime from '../datetime/main.vue'
export default {
	components: {
		flDateTime
	},
	data() {
		return {
			width: 'auto',
			colorFont: '#555',
			slide: 'hide',
			marginTop: '0px',
			exibirNotificacoes: false,
			lista: [],
			historicos: '',
			atualizaLista: true,
			exibirHistorico: false,

			carregando: false,
			buscouHistorico: false,
			erro: '',
			form: {
				data: ''
			}
		}
	},

	mounted() {
		if (this._isMobile) {
			this.width = this._width + 'px'
			this.marginTop = '-60px'
		} else {
			this.width = '490px'
		}

		bus.$on('exibir-notificacoes', (lista) => {
			this.exibirNotificacoes = true
			this.slide = this._isMobile ? 'slideInRight' : 'slideInLeft'
			this.limpaHistorico()

			var height = this._height

			this.lista = this.processaLista(lista)

			this.lista = lista.map((item) => {
				item.dt = moment(item.data_envio).locale(this._getLangDp).fromNow()
				return item
			})

			this.$nextTick(() => {
				var configScroll = {
					color: '#1976D2',
					size: '4px',
					height: height - 120 + 'px',
					alwaysVisible: false,
					// distance: '-2px',
					railOpacity: 0.9
				}

				$(this.$refs.configScrollN).slimScroll(configScroll)

				var configScroll2 = {
					color: '#1976D2',
					size: '4px',
					height: height - 234 + 'px',
					alwaysVisible: false,
					// distance: '-2px',
					railOpacity: 0.9
				}

				$(this.$refs.configScrollS).slimScroll(configScroll2)
				this.$forceUpdate()
			})
		})

		bus.$on('atualiza-notificacoes', (lista) => {
			if (this.atualizaLista) {
				this.lista = this.processaLista(lista)
			}
		})
	},

	methods: {
		processaLista(lista) {
			return lista.map((item) => {
				item.dt = moment(item.data_envio).locale(this._getLangDp).fromNow()
				item.class = ''
				item.excluindo = false

				// se a notificação tem ação no sistema
				if (item.acao == 1) {
					// solicitação
					if (item.id_agrupamento == 2) {
						item.rota = 'solicitacao'
						item.params = {id: item.parametros}
					}

					// ordem de missão
					if (item.id_agrupamento == 4) {
						item.rota = 'ordem'
						item.params = {id: item.parametros}
					}

					// diário de bordo
					if (item.id_agrupamento == 12) {
						item.rota = 'diario-de-bordo-piloto'
						item.params = {id: item.parametros}
					}

					// mensagem
					if (item.id_agrupamento == 15) {
						item.rota = 'monitoramento'
						item.params = {id: item.parametros}
					}

					// leitura obrigatória
					if (item.id_agrupamento == 20) {
						item.rota = 'indice-documento'
						item.params = {id: item.parametros}
					}
				}

				return item
			})
		},

		limpaHistorico() {
			this.exibirHistorico = false
			this.colorFont = '#555'
			this.form.data = ''
			this.buscouHistorico = false
			this.historicos = ''
		},

		clickCarregaHistorico() {
			if (this.form.data == '') {
				this.erro = this._traducao('global', 'naoSelecionouData')
			} else {
				this.erro = ''
				this.carregando = true
				var dt = this._dateToDateSQL(this.form.data, $sessao.getDateFormat())
				this._httpGet(
					'/Notificacao_sistema/get_by_data/' + $sessao.getId() + '/' + dt,
					(retorno) => {
						if (retorno._request && retorno._status) {
							this.carregando = false
							this.historicos = this.processaLista(retorno.lista)
							this.buscouHistorico = true
						}
					}
				)
			}
		},

		clickLimparTodas() {
			if (this.lista.length === 0) return
			this.atualizaLista = false
			this.lista.map((item) => {
				return {
					...item,
					excluindo: true
				}
			})
			this.$forceUpdate()
			let notificacoes = []
			for (let i = 0; i < this.lista.length; i++) {
				notificacoes.push(this.lista[i])
			}

			this._httpPost(
				'/Notificacao_sistema/excluir',
				notificacoes,
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.atualizaLista = true
						this.lista = []
						this.$emit('qtd-lista', this.lista.length)
						this.$forceUpdate()
					}
				}
			)
		},

		clickLimpar(item, index) {
			this.atualizaLista = false

			this.lista[index].excluindo = true
			this.$forceUpdate()

			var data = {
				id: item.id
			}

			this._httpPost('/Notificacao_sistema/salvar', data, (retorno) => {
				if (retorno._request && retorno._status) {
					this.atualizaLista = true
					this.lista[index].class = 'fadeOutLeft'

					setTimeout(() => {
						this.lista.splice(index, 1)
						this.$emit('qtd-lista', this.lista.length)
						this.$forceUpdate()
					}, 800)
					this.$forceUpdate()
				}
			})
		},

		clickVer(item) {
			// this.$router.go({name: item.rota, params: item.params})
			bus.$emit('notificacao-acao', {name: item.rota, params: item.params})
			this.slide = 'slideOutLeft'
		}
	}
}
</script>

<style lang="less">
.notificacoes {
	width: 500px;
	height: 100%;
	background: #f9f9f9;
	position: fixed;
	z-index: 1001;
	padding: 10px;
	box-shadow: 3px 0px 20px #bbb;

	.link-historico {
		color: #1976d2;
		font-size: 12px;
		margin-left: -3px;
		margin-top: 3px;
	}

	.link-limpar {
		color: #e65100;
		font-size: 12px;
		margin-left: -3px;
	}

	.link-ver {
		color: #1976d2;
		font-size: 12px;
	}

	.fechar-notificacao {
		font-size: 25px;
		margin-top: 0px;
		margin-right: 1px;
	}

	.item-notificacao {
		border: 1px solid #ccc;
		margin: 7.5px 0px 7.5px 17px;
		border-radius: 4px;
		padding: 8px 8px;
		background: #fff;
	}
}
</style>